import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { APIService } from '../api.service';
import { DataService } from '../services/data.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FinancialYearcountComponent } from '../financial-yearcount/financial-yearcount.component';
import { CommonService } from '../services/common.service';
import * as xlsx from 'xlsx';
import { MatPaginator } from '@angular/material/paginator';
import { AnyMxRecord } from 'dns';
import { TOUCH_BUFFER_MS } from '@angular/cdk/a11y';

// export interface HeadList {
//   head: string;
//   opening: number;
//   debit: number;
//   credit: number;
//   closing: number;
// }

// const ELEMENT_DATA: HeadList[] = [
//   {
//     head: 'Google', opening: 343323, debit: 32354545444,
//     credit: 454353 , closing: 4545533
//   },
//   {
//     head: '0.37 GAL. FINE WIRE', opening: 44543, debit: 7878,
//     credit: 345 , closing: 6565
//   },
//   {
//     head: 'Shine', opening: 8765, debit: 2323233,
//     credit: 7876 , closing: 4534
//   },
  
// ];

@Component({
  selector: 'app-head-record',
  templateUrl: './head-record.component.html',
  styleUrls: ['./head-record.component.scss']
})
export class HeadRecordComponent implements OnInit {

  displayedColumns: string[] = ['head', 'opening', 'debit', 'credit', 'closing'];
  // dataSource = new MatTableDataSource<HeadList>(ELEMENT_DATA);
  selectedFY: any;
  fromDate: any;
  toDate: any;
  ledger: any = [];
  Date: Array<any> = [];
  financialYears: any = [];
  ERP_Agn: Array<any> = [];
  agencyData: any = [];
  jarvisData: any = [];
  data: any = [];
  displayData: any = [];
  heads: any = [];
  ledgerData: any = [];
  headsData: any = [];
  tree: any = [];
  acctStartDT: Date = new Date();
  date = new Date();
  dataSource = new MatTableDataSource();

  @ViewChild('LRTable', { static: false }) LRTable!: ElementRef;
  @ViewChild(MatSort) sort!: MatSort;

  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  isShowSubHeads: boolean = false;
  lederOpen: boolean = false;
  hideZeroLevelLdgr: boolean = true;
  headDataList: any = [];
  show: any = {
    edit: true,
    save: false,
    querySubHead: true,
  };
  disable: any = {
    fromInput: true,
    toInput: true
  };

  //export to excel
  tableToExcel = (function () {
    var uri = 'data:application/vnd.ms-excel;base64,'
        , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
        , base64 = function (s:any) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function (s:any, c:any) { return s.replace(/{(\w+)}/g, function (m:any, p:any) { return c[p]; }) }

    return function (table: any, name : string, fileName:any) {
        if (!table.nodeType) table = table
        var ctx = { worksheet: name || 'Worksheet', table: table }
        var link = document.createElement("a");
        link.download = fileName || 'download.xls';
        link.href = uri + base64(format(template, ctx));
        link.click();
    }
  })()

  constructor(
    private router: Router, private appService: DataService, private apiService: APIService,
    private modalService: NgbModal, private commonService: CommonService, private commonSer : CommonService) { }

  HeadName: string = '';

  ngOnInit(): void {

   

    let tmpERP_Agn = this.apiService.getCookie("ERP_Agn");
    if (tmpERP_Agn) {
      this.ERP_Agn = JSON.parse(tmpERP_Agn);
    }
    if (this.ERP_Agn.length > 0) {
      this.acctStartDT = new Date(this.ERP_Agn[0].AccountStartDT);
    }

    this.financialYears = this.commonService.checkFinancialYear(this.acctStartDT, new Date());
    // this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;

    // this.fromDate = new Date(this.date.getFullYear(), 3, 1);
    // this.toDate = new Date(this.date.getFullYear()+1, 2, 31);

    let fromDT = this.commonSer.GetParam('fromDT');
    let toDT = this.commonSer.GetParam('toDT');

    if(fromDT && toDT) {
      fromDT = String(fromDT);
      toDT = String(toDT);

      this.fromDate = new Date(decodeURIComponent(fromDT));
      this.toDate = new Date(decodeURIComponent(toDT));

      const currFY = this.commonService.checkFinancialYear(this.fromDate, this.toDate);
      let fdt = fromDT.split('-')[0] + '-' + fromDT.split('-')[1];
      let tdt = toDT.split('-')[0] + '-' + toDT.split('-')[1];

      if(currFY.length > 1 || fdt != '01-Apr' || tdt != '31-Mar') {
        this.selectedFY = 'Other';
      } else {
        this.selectedFY = this.fromDate.getFullYear() + '-' + this.toDate.getFullYear();
      }
    } else {
      this.selectedFY = this.financialYears[this.financialYears.length - 1].FY;
      let currentDate = new Date();
      this.fn_Set_FinancialYear(currentDate);
    }

    // Get Head List of In Head Recorde
    let HeadData = this.apiService.getCookie("Heads");
    if (HeadData) {
      this.headDataList = JSON.parse(HeadData);
      console.log("heads list", this.headDataList);
    }

    this.getData();    
  }

  getData() {
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    let data = [{
      fromDT: new Date(this.fromDate).customFormat('#DD#-#MMM#-#YY#'),
      toDT: new Date(this.toDate).customFormat('#DD#-#MMM#-#YY#')
   
    }];
    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'get',
      moduleID: 1,
      data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      alert(res.message);
    }
  }
  //successResp - success  get handler
  successResp(res: any) {
      if (res) {
        //this.isShowLoading = false;
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          this.data = reponseData;
          this.heads = this.data.Table2;
          this.ledger = this.data.Table1;

          if (this.heads.length == 0) {
            alert('Please initialize your Accounts setup.');
            window.location.href = "../../main.html";
            return;
          }
          this.appService.getFavLedger(this.ledger);
          //this.apiService.setCookie("Ledger", JSON.stringify(this.ledger));
          //this.isFav = false;
          this.apiService.setCookie("Ledger", JSON.stringify(this.ledger));


          if(this.show.querySubHead && this.commonSer.GetParam('hid')) {
            let hid = decodeURIComponent(String(this.commonSer.GetParam('hid')));
            let head = this.headDataList.find((head: any) => head.HeadID == hid);
            this.HeadName = head.HeadName;
            this.openSubHeadList(this.HeadName);
            this.show.querySubHead = false;
          }
          else {
            if(this.HeadName != ''){
              this.headsData = $.grep(this.heads, (e: any) => { return (e.HeadName == this.HeadName) });
              this.ledgerData = $.grep(this.ledger, (e: any) => { return (e.HeadID == this.headsData[0].HeadID)});
            } else {
              this.headsData = $.grep(this.heads, (e: any) => { return e.ParentHeadID == 0 });
            }
            this.dataPush();
          }
        }
      }
  }

  dataPush() {
    this.displayData = [];
    
    // Push HEAD data (subgroups)
    this.headsData.forEach((element: any) => {
      element.CloBal.charAt(0) == "-" ? element.ClosingBal = element.CloBal.substring(1) + ' Cr' : element.ClosingBal = element.CloBal + ' Db';
      element.CrAmt < 0 ? element.CraditAmount = Math.abs(element.CrAmt) + ' Db' : element.CraditAmount = element.CrAmt + ' Cr';
      element.DbAmt < 0 ? element.DebitAmount = Math.abs(element.DbAmt) + ' Db' : element.DebitAmount = element.DbAmt + ' Cr';
      element.OpBal < 0 ? element.OpeningBalance = Math.abs(element.OpBal) + ' Db' : element.OpeningBalance = element.OpBal + ' Cr';

      this.displayData.push({
        name: element.HeadName,
        currentBal: element.CrAmt,
        id: element.HeadID,
        parentHeadID: element.ParentHeadID,
        headLevel: element.LevelPath,
        isHead: true,
        CloBal: element.CloBal,
        CrAmt: element.CrAmt,
        DbAmt: element.DbAmt,
        OpBal: element.OpBal,
        ClosingBal: element.ClosingBal,
        CraditAmount: element.CraditAmount,
        DebitAmount: element.DebitAmount,
        OpeningBalance: element.OpeningBalance,
        LedgerType: element.LedgerType
      });
    });

    // Push LEDGER data
    this.ledgerData.forEach((element: any) => {
      element.CloBal.charAt(0) == "-" ? element.ClosingBal = element.CloBal.substring(1) + ' Cr' : element.ClosingBal = element.CloBal + ' Db';
      element.CrAmt < 0 ? element.CraditAmount = Math.abs(element.CrAmt) + ' Cr' : element.CraditAmount = element.CrAmt + ' Db';
      element.DbAmt < 0 ? element.DebitAmount = Math.abs(element.DbAmt) + ' Cr' : element.DebitAmount = element.DbAmt + ' Db';
      element.OpBal < 0 ? element.OpeningBalance = Math.abs(element.OpBal) + ' Cr' : element.OpeningBalance = element.OpBal + ' Db';

      this.displayData.push({
        name: element.LedgerName,
        currentBal: element.CrAmt,
        id: element.LedgerID,
        openingBal: element.OpBal,
        isHead: false,
        balanceHistory: element.balanceHistory,
        CloBal: element.CloBal,
        CrAmt: element.CrAmt,
        DbAmt: element.DbAmt,
        OpBal: element.OpBal,
        HeadID: element.HeadID,
        IsCustomer: element.IsCustomer,
        IsFav: element.IsFav,
        IsSupplier: element.IsSupplier,
        RelAgencyID: element.RelAgencyID,
        RelID: element.RelID,
        ClosingBal: element.ClosingBal,
        CraditAmount: element.CraditAmount,
        DebitAmount: element.DebitAmount,
        OpeningBalance: element.OpeningBalance,
        LedgerType: element.LedgerType,
        BankName: element.BranchName,
        Branch: element.BranchCode,
        IFSCCode: element.IFSCCode,
        AccountNo: element.MICRCode,
        IsBank: element.IsBank,
        BankID: element.BankID
      });
    });

    this.displayData.sort((a: any, b: any) => {
      // Sort by isHead first (heads before ledgers), then by name
      if (a.isHead && !b.isHead) return -1;
      if (!a.isHead && b.isHead) return 1;
      return a.name.localeCompare(b.name);
    });

    this.dataSource.data = this.displayData;
    this.zeroHide();
  }

  treeIndex(i: any, t: any) {
    this.headsData = $.grep(this.heads, (e: any) => { return (e.ParentHeadID == i.headID) })
    this.ledgerData = $.grep(this.ledger, (e: any) => { return (e.HeadID == i.headID) })
    this.dataPush();
    //Remove from tree
    this.tree.splice(t + 1, this.tree.length - 1);
  }

  allHeads() {
    //Open all heads
    this.tree = [];
    this.ledgerData = [];
    this.headsData = [];
    this.displayData = [];
    this.isShowSubHeads = true;
    this.HeadName = "";
    this.headsData = $.grep(this.heads, (e: any) => { return e.ParentHeadID == 0 })
    this.dataPush();
  }

   //Click on sub-group
  openSubHead(i: any) {
 
    // this.displayData = [];
    //Open Sub-group
    //this.accountsComponent.isShowRVoucher = true;
    if (i.isHead == true) {

      this.headsData = $.grep(this.heads, (e: any) => { return (e.ParentHeadID == i.id) });
      this.ledgerData = $.grep(this.ledger, (e: any) => { return (e.HeadID == i.id) });
     
      this.dataPush();
      let obj = {
        headID: i.id,
        parentHeadID: i.parentHeadID,
        headName: i.name,
        headLevel: i.headLevel
      }
      
      const isPresent = this.tree.find((node: any) => node.headID == obj.headID);
      if(!isPresent) {
        this.tree.push(obj);
      }
      
      this.isShowSubHeads = true;
      }
    else
    {
      // Direct To Ledger Touch To Open ledgerRecorde Page.
      if(i.id)
      {
        this.lederOpen = true;

        // let startYear = this.selectedFY.split("-")[0];
        // let endYear = Number(this.selectedFY.split("-")[0]) + 1;        

        let fromDT = new Date(this.fromDate).customFormat("#DD#-#MMM#-#YYYY#");
        let toDT = new Date(this.toDate).customFormat("#DD#-#MMM#-#YYYY#");
        let isLive = this.apiService.fn_isLiveURL();
        
        window.open((isLive ? '/ERP' : '') + '/LedgerRecord?lid='+ encodeURIComponent(i.id) + '&fromDT=' + encodeURIComponent(fromDT) + '&toDT=' + encodeURIComponent(toDT));
      }
      else
      {
          this.lederOpen = false;
      }
    }
    this.zeroHide();  

  }


  getFromToDate() {
    this.fromDate = new Date(this.Date[0].fdt);
    this.toDate = new Date(this.Date[0].tdt)
  }

  ddlchangeYear() {
    if (this.selectedFY != 'Other') {
      let selectedYear;
      selectedYear = this.selectedFY.split("-")[0] + "";
      let toDate = (Number(selectedYear) + 1) + "/03/31";
      //this.selectedDate = toDate;

      // let accountDate: Array<any> = [{
      //   fdt: '1-Apr-' + selectedYear[0],
      //   tdt: '31-Mar-' + selectedYear[1],
      //   selectedFy: this.selectedFY
      // }];
      // this.apiService.setCookie("AccountsDates", JSON.stringify(accountDate));
      this.fn_Set_FinancialYear(toDate);
    }
  }

  fn_Set_FinancialYear(ToDT: any) {
    var Date1 = new Date(ToDT);
    var Year;
    var IsPrevios = 0;
    if (Date1.getMonth() < 3) {
      Year = Date1.getFullYear() - 1
      IsPrevios = 1;
    } else {
      Year = Date1.getFullYear() + 1
      IsPrevios = 0;
    }
    if (IsPrevios == 1) {
      this.fromDate = new Date(Year + "/04/01");
      this.toDate = new Date(Date1.getFullYear() + "/03/31");
    }
    else if (IsPrevios == 0) {
      this.fromDate = new Date(Date1.getFullYear() + "/04/01");
      this.toDate = new Date(Year + "/03/31");
    }
    this.getData();
  }

  fn_ChangeDate() {
    // Here Set Accounting Year of Selected Date
    var Date2 = new Date(this.fromDate);
    var Date1 = new Date(this.toDate);
    var acctStartDT = new Date(this.acctStartDT);
    let CurrentDate = new Date();

    if (Date1 < acctStartDT) {
      alert("Please select date after " + this.acctStartDT.customFormat("#DD#-#MMM#-#YY#"));
      this.fn_Set_FinancialYear(CurrentDate);
      return;
    }

    var Year;
    var IsPrevios = 0;
    if (Date1.getMonth() < 3) {
      Year = Date1.getFullYear() - 1
      IsPrevios = 1;
    } else {
      Year = Date1.getFullYear() + 1
      IsPrevios = 0;
    }
    if (IsPrevios == 1) {
      Date2 = new Date(Year + "/04/01");
      //this.fromDate = new Date(Year + "/04/01");
      //$scope.ToDate = new Date(Date1.getFullYear() + "/03/31");
    }
    else if (IsPrevios == 0) {
      Date2 = new Date(Date1.getFullYear() + "/04/01");
      //this.fromDate = new Date(Date1.getFullYear() + "/04/01");
      // $scope.ToDate = new Date(Year + "/03/31");
    }

    this.heads = [];
    this.getData();

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  exportToExcel() {
    var currHead = "";
    var html = "";
    var strHeader = "";
    var body = "";
    var unitOp = '';
    var unitClo = '';
    let totalOp = 0, totalDb = 0, totalCr = 0, totalClo = 0;

    if (this.isShowSubHeads && this.tree.length > 0) {
      currHead = this.tree[this.tree.length - 1].headName;
    }

    // Title
    html += "<table><tr>";
    html += "<th style='text-align: left;'>Head Record</th>";
    html += "</table></tr>";

    html += "<table><tr></table></tr>";
    html += "<table><tr>";
    let date: any = new Date(this.fromDate).customFormat("#DD#-#MMM#-#YYYY#") + " to " + new Date(this.toDate).customFormat("#DD#-#MMM#-#YYYY#") 

    html += (currHead != "") ? "<p><b>Head : </b>" + currHead + "; " : "<p>";
    html += "<b>Period : </b>"+ (this.selectedFY != 'Other' ?  this.selectedFY  : date) + "</p>"
    html += "<table><tr>";
    html += "<p>" + (this.isShowSubHeads ? "All" : "");

    if (this.tree.length > 0) {
      this.tree.forEach((item:any) => {
        html += " > " + item.headName;
      });
      html += "<table><tr>";
    }

    strHeader += "<th style='text-align: left;'>Head</th>";
    strHeader += "<th style='text-align: right;'>Opening</th>";
    strHeader += "<th style='text-align: right;'>Debit</th>";
    strHeader += "<th style='text-align: right;'>Credit</th>";
    strHeader += "<th style='text-align: right;'>Closing</th>";

    strHeader += "</tr>"
    html += strHeader;

    this.dataSource.data.forEach((item: any) => {
      body += "<tr>";
      body += "<td style='text-align: left;" + (item.isHead ? " font-style: italic;'" : "'") + ">" + item.name + "</td>";

      if (Number(String(item.OpBal).replaceAll(",","")) < 0) {
        unitOp = 'Cr'
      } else {
        unitOp = 'Db'
      }
      
      let opening = Number(String(item.OpBal).replaceAll(",", "")).toFixed(2);
      opening = String(opening.replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "");
      body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" + opening + " " + unitOp +"</td>";

      let dbAmt = String(Number(String(item.DbAmt).replaceAll(",", "")).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "");
      let crAmt = String(Number(String(item.CrAmt).replaceAll(",", "")).toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "");
      
      body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" + dbAmt + "</td>";
      body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" + crAmt + "</td>";
      
      if (Number(String(item.CloBal).replaceAll(",","")) < 0) {
        unitClo = 'Cr'
      } else {
        unitClo = 'Db'
      }

      let closing = Number(String(item.CloBal).replaceAll(",", "")).toFixed(2);
      closing = String(closing.replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "");
      body += "<td style='text-align: right; mso-number-format: \"#,##0.00\"'>" + closing + " " + unitClo +"</td>";
      body += "</tr>";

      // Calculate the Grand Total
      totalOp += Number(String(item.OpBal).replaceAll(",", ""));
      totalDb += Number(String(item.DbAmt).replaceAll(",", ""));
      totalCr += Number(String(item.CrAmt).replaceAll(",", ""));
      totalClo += Number(String(item.CloBal).replaceAll(",", ""));
    });
    
    unitOp = totalOp < 0 ? 'Cr' : 'Db';
    unitClo = totalClo < 0 ? 'Cr' : 'Db';

    body += "<tr></tr>";
    body += "<tr>";
    body += "<td style='text-align: left; font-weight: bold;'>Grand Total</td>";
    body += "<td style='text-align: right; font-weight: bold; mso-number-format: \"#,##0.00\"'>" + String(totalOp.toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "") + " " + unitOp + "</td>";
    body += "<td style='text-align: right; font-weight: bold; mso-number-format: \"#,##0.00\"'>" + String(totalDb.toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "") + "</td>";
    body += "<td style='text-align: right; font-weight: bold; mso-number-format: \"#,##0.00\"'>" + String(totalCr.toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "") + "</td>";
    body += "<td style='text-align: right; font-weight: bold; mso-number-format: \"#,##0.00\"'>" + String(totalClo.toFixed(2).replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,'),).replace("-", "") + " " + unitClo + "</td>";
    body += "</tr>";

    html += body;
    html += "</table>";
    this.tableToExcel(html, "Sheet1", "Head Record" + (currHead != "" ? " - " + currHead : ""));
  }

  backBtn() {
    this.router.navigate(['/accounts']);
  }

  printVoucher() {

    // this.appService.ledgerRecordPrintData(this.voucher);

    // let Lid: number = this.ledger.id ? this.ledger.id : this.ledger.LedgerID;
    // window.open('LedgerRecordPrint?LID=' + Lid + '&fdt=' + new Date(this.fromDate).customFormat('#DD#-#MMM#-#YY#') + '&tdt=' + new Date(this.toDate).customFormat('#DD#-#MMM#-#YY#') + '&lname=' + encodeURIComponent(this.ledgername), '_blank', 'Height= 900px, Width= 1100px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No');
  }

  zeroHide() {
    if (this.hideZeroLevelLdgr) {
      let valeQty = this.displayData.filter((i: any) => !(i.OpBal == 0 && i.DbAmt == 0 && i.CrAmt == 0 && i.CloBal == 0));
      
      if (valeQty.length > 0) {
        this.dataSource.data = valeQty;
      }
      else {
        // ToDo: What is best Response for all zero items
      }
   } 
   else {
    this.dataSource.data = this.displayData;
   }
  }

  openSubHeadList(i: any) {
    if (i == '') {
      this.allHeads();
      return;
    }

    // Find the Current Head Object based on the Name passed
    let currentHead = this.heads.find((e: any) => e.HeadName == i);

    if (currentHead) {
      
      // Fetch Direct Children (Subgroups): Filter heads where ParentHeadID matches the Current HeadID
      this.headsData = $.grep(this.heads, (e: any) => { 
        return (e.ParentHeadID == currentHead.HeadID) 
      });

      // Fetch Ledgers: Filter ledgers where HeadID matches the Current HeadID
      this.ledgerData = $.grep(this.ledger, (e: any) => { 
        return (e.HeadID == currentHead.HeadID) 
      });

      this.dataPush();

      // Update the Breadcrumb Tree
      let obj = {
        headID: currentHead.HeadID,
        parentHeadID: currentHead.ParentHeadID,
        headName: currentHead.HeadName,
        headLevel: currentHead.LevelPath
      };

      const isPresent = this.tree.find((node: any) => node.headID == obj.headID);
      if (!isPresent) {
        this.tree.push(obj);
      }

      this.isShowSubHeads = true;
    }
  }

  editPeriod() {
    this.show.edit = false;
    this.show.save = true;
    this.disable.fromInput = false;
    this.disable.toInput = false;
  }

  changePeriod() {
    this.fn_ChangeDate();
    this.show.edit = true;
    this.show.save = false;
    this.disable.fromInput = true;
    this.disable.toInput = true;
  }
}
